import { useState } from "react";
import ReactAppContainer from "@iloq/shared-react/ReactAppContainer";
import { VueContextType } from "@iloq/shared-react/vueContext";
import { Fragment, ReactNode } from "react";
import { IntlProvider } from "react-intl";
import { Login } from "./login";

export function LoginRoot(vueProps: VueContextType): ReactNode {
  const [locale, setLocale] = useState(vueProps.locale || "en");

  return (
    <ReactAppContainer vueProps={vueProps}>
      <IntlProvider locale={locale} messages={vueProps.messages[locale]} textComponent={Fragment}>
        <Login {...vueProps} setLocale={setLocale} />
      </IntlProvider>
    </ReactAppContainer>
  );
}
